import React from "react";
import { Paragraph, Anchor, Text, Heading, Box } from "grommet";
import { routes } from "../../const/routes";
export var Breadcrumbs = function Breadcrumbs(_ref) {
  var location = _ref.location;
  var firstLabel = routes.main.name;
  var secondRoute = Object.values(routes).find(function (r) {
    return r.path === location.pathname;
  });
  var isSecondMain = secondRoute ? secondRoute.name === firstLabel : false;
  var secondLabel = secondRoute && !isSecondMain ? secondRoute.name : "";
  return /*#__PURE__*/ React.createElement(
    Box,
    {
      pad: {
        horizontal: "large",
        bottom: "32px",
      },
      margin: {
        bottom: "large",
      },
      background: {
        color: "site-colors-1",
      },
      round: "small",
      gap: "xlarge",
    },
    /*#__PURE__*/ React.createElement(
      Box,
      {
        pad: {
          top: "large",
        },
      },
      /*#__PURE__*/ React.createElement(
        Paragraph,
        {
          size: "small",
          color: "rgba(0, 0, 0, 0.3)",
          style: {
            display: "flex",
            flexDirection: "row",
            gap: "2%",
          },
        },
        /*#__PURE__*/ React.createElement(Anchor, {
          href: "/",
          color: "rgba(0, 0, 0, 0.3)",
          label: firstLabel,
          style: {
            textDecoration: "none",
          },
        }),
        secondLabel && /*#__PURE__*/ React.createElement(Text, null, " > "),
        secondLabel
      )
    ),
    /*#__PURE__*/ React.createElement(
      Heading,
      {
        level: 1,
        color: "#E21A25",
        style: {
          textTransform: "uppercase",
        },
      },
      secondLabel
    )
  );
};
